module.exports = __webpack_public_path__ + "img/popup-game-sucai.9123ab09.png";